import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PrintIcon from '@material-ui/icons/Print';
import { PDFViewer } from '@react-pdf/renderer';

import SharedTitle from './SharedTitle';
import PrintOcurrencePDF from './PrintOcurrencePDF';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
}));

const PrintOcurrence = ({ ocurrence }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SharedTitle icon={<PrintIcon />} title="Imprimir" />

      <Box width="100%" height="75vh">
        <PDFViewer width="100%" height="100%">
          <PrintOcurrencePDF ocurrence={ocurrence} />
        </PDFViewer>
      </Box>
    </div>
  );
};

export default PrintOcurrence;
